<template>
  <div class="tab" :class="{ 'is-active': active, 'is-done': done }">
    <div
      class="tab-header page-title"
      :class="{ 'is-interactive': _events['click:header'] != undefined }"
      @click="$emit('click:header')"
    >
      <div class="container">
        <div class="tab-prefix">
          <div class="tab-number">
            <span v-if="!done">
              {{ number }}
            </span>
            <span v-else class="icon has-text-primary">
              <font-awesome-icon icon="check"></font-awesome-icon>
            </span>
          </div>
        </div>
        <div class="tab-content">
          {{ title }}
        </div>
      </div>
    </div>
    <div v-if="active" class="tab-body">
      <div class="container">
        <div class="tab-prefix">
          <slot name="body-prefix"></slot>
        </div>
        <div class="tab-content">
          <slot>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Illum sed
            iure accusantium sapiente quasi nobis officiis quo magnam excepturi
            voluptatum quisquam laboriosam quidem a eius fugiat illo aspernatur,
            sunt dolores.
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tab',
  props: {
    title: {
      type: String
    },
    number: {
      type: String
    },
    active: {
      type: Boolean,
      default: false
    },
    done: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.tab {
  &.is-done {
    .tab-header {
      .tab-prefix,
      .tab-content {
        opacity: 0.5;
      }
    }
  }
  .tab-header {
    height: 80px;
    .container {
      align-items: center;
    }
    .tab-number {
      width: 48px;
      height: 48px;
      border-radius: $radius-rounded;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      font-size: 2.4rem;
      .icon {
        font-size: 1.5rem;
      }
    }
  }
  .container {
    display: flex;
    height: 100%;
  }
  .tab-prefix {
    width: 80px;
    margin-left: 20px;
  }
  .tab-content {
    flex: 1 1 0;
  }
  .tab-body {
    .container {
      padding: $block-spacing * 2 0 $block-spacing * 3;
    }
  }
}
</style>
